
import FontFamily from '@tiptap/extension-font-family';
import TextStyle from '@tiptap/extension-text-style';
import Color from '@tiptap/extension-color';
import { Extension } from '@tiptap/core';
import { Plugin } from 'prosemirror-state';

// Email-safe fonts
const EMAIL_SAFE_FONTS = [
  'Arial, sans-serif',
  'Verdana, sans-serif',
  'Georgia, serif',
  'Times New Roman, serif',
  'Tahoma, sans-serif',
];

// Extension to enforce email-safe formatting
const EmailSafeFormatting = Extension.create({
  name: 'emailSafeFormatting',
  
  addGlobalAttributes() {
    return [
      {
        types: ['textStyle'],
        attributes: {
          // Use pt for font size in emails
          fontSize: {
            default: null,
            parseHTML: element => element.style.fontSize || null,
            renderHTML: attributes => {
              if (!attributes.fontSize) {
                return {};
              }
              
              // Ensure pt unit is used
              let fontSize = attributes.fontSize;
              if (!fontSize.includes('pt') && !isNaN(parseFloat(fontSize))) {
                fontSize = `${fontSize}pt`;
              }
              
              return {
                style: `font-size: ${fontSize}`,
              };
            },
          },
        },
      },
    ];
  },
});

// Customize FontFamily extension to only allow email-safe fonts
const EmailSafeFontFamily = FontFamily.configure({
  types: ['textStyle'],
  // Remove the defaultFontFamily property as it's not valid
  // and instead handle the default via the toolbar
});

// Export a collection of email-safe extensions
export const EmailSafeExtensions = [
  TextStyle,
  EmailSafeFontFamily,
  Color,
  EmailSafeFormatting,
];

// Extension to strip out unsupported HTML elements for emails
export const CleanHtml = Extension.create({
  name: 'cleanHtml',
  
  addProseMirrorPlugins() {
    return [
      // Return a proper ProseMirror plugin with minimum required properties
      new Plugin({
        // This is a placeholder for more complex HTML cleaning
        // In a real implementation, you would add logic to convert divs to paragraphs,
        // remove unsupported attributes, etc.
        props: {},
      })
    ];
  },
});
